import { TariffWithVerificationValues } from '@src/stores/product';

/**
 * Removes verification values that exceed the current quantity and returns update payload if needed
 */
export const cleanExcessVerificationValues = (
  tariffWithVerificationValues: TariffWithVerificationValues[],
  tariffTypeId: string,
  quantity: number,
): {
  cleanedValues: TariffWithVerificationValues[];
  updatePayload?: { tariffTypeId: string; values: TariffWithVerificationValues['verificationValues'] };
} => {
  const newTariffWithVerificationValues = [...tariffWithVerificationValues];

  const tariffIndex = newTariffWithVerificationValues.findIndex(
    (verification) => verification.tariffTypeId === tariffTypeId,
  );

  if (tariffIndex === -1) {
    return { cleanedValues: newTariffWithVerificationValues };
  }

  const tariff = newTariffWithVerificationValues[tariffIndex];
  if (!tariff?.verificationValues) {
    return { cleanedValues: newTariffWithVerificationValues };
  }

  // Filter out verification values that exceed the current quantity
  const filteredVerificationValues = tariff.verificationValues.filter(
    (verification) => verification.tariffUnitIndex < quantity,
  );

  // Check if any values were removed
  const hasValuesRemoved = tariff.verificationValues.length !== filteredVerificationValues.length;

  newTariffWithVerificationValues[tariffIndex] = {
    ...tariff,
    verificationValues: filteredVerificationValues,
  };

  return {
    cleanedValues: newTariffWithVerificationValues,
    updatePayload: hasValuesRemoved ? { tariffTypeId, values: filteredVerificationValues } : undefined,
  };
};
